import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import AlertService from '../../common/AlertService'

export const getAlertHighlight = createAsyncThunk(
  'alerts/getAlertHighlight',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertHighlight(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getAlertCriteriaDynamic
export const getAlertCriteriaDynamic = createAsyncThunk(
  'alerts/getAlertCriteriaDynamic',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertCriteriaDynamic(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getAlertList = createAsyncThunk(
  'alerts/getAlertList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertList(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const searchCompany = createAsyncThunk(
  'alerts/searchCompany',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.searchCompany(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const searchIndustry = createAsyncThunk(
  'alerts/searchIndustry',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.searchIndustry(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const deleteAlert = createAsyncThunk(
  'alerts/deleteAlert',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.deleteAlert(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const markAsReadAlert = createAsyncThunk(
  'alerts/markAsReadAlert',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.markAsReadAlert(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const markAsUnreadAlert = createAsyncThunk(
  'alerts/markAsUnreadAlert',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.markAsUnreadAlert(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
